<div class="input-switch-container">
  <p-toggleswitch [(ngModel)]="value" [disabled]="disabled()"></p-toggleswitch>
  <span>{{ label() }}</span>
</div>
